import api from './api';
import { CPB_URL } from './servers';

export const fetchBitacoraSync = (params) =>
  api.post(`${CPB_URL}/bitacora/getBitacoraSincronizacion`, params);
